import { useCallback } from 'react';
import { CanvasElementType, CanvasTextNode } from '../canvas-types';
import { RfNodeTextNode } from '../canvas-types/nodeTypesData';
import { NODE_Z_INDEX_TEXT } from '../const/zIndex';

const emptyTextNodes: RfNodeTextNode[] = [];

const useTextNodesFactory = () => {
  const createFlowNodesFromSweepTextNodes = useCallback(
    ({ canvasTextNodes }: { canvasTextNodes?: CanvasTextNode[] }): RfNodeTextNode[] => {
      if (!canvasTextNodes) {
        return emptyTextNodes;
      }
      const nodes: RfNodeTextNode[] = [];

      canvasTextNodes?.forEach((textNode) => {
        nodes.push({
          id: textNode.id,
          type: CanvasElementType.TEXT_NODE,
          data: {
            richText: textNode.richText,
            textScale: textNode.textScale ?? 1,
          },
          position: textNode.xyPosition,
          width: textNode.width,
          height: textNode.height,
          dragHandle: '.drag-handle',
          parentId: textNode.sectionId,
          zIndex: NODE_Z_INDEX_TEXT,
        });
      });

      return nodes;
    },
    [],
  );

  return {
    createFlowNodesFromSweepTextNodes,
  };
};

export default useTextNodesFactory;
